var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2962_94285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3417 12.8356C19.4957 12.8356 22.8632 11.339 22.8632 9.49276C22.8632 7.64655 19.4957 6.1499 15.3417 6.1499C11.1878 6.1499 7.82031 7.64655 7.82031 9.49276C7.82031 11.339 11.1878 12.8356 15.3417 12.8356Z",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82031 9.49268V19.5212C7.82031 21.3598 11.1632 22.8641 15.3417 22.8641C19.5203 22.8641 22.8632 21.3598 22.8632 19.5212V9.49268",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8632 14.5073C22.8632 16.3459 19.5203 17.8502 15.3417 17.8502C11.1632 17.8502 7.82031 16.3459 7.82031 14.5073",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1728 2.82185C13.2197 1.61653 10.9463 1.03361 8.65424 1.15041C4.49238 1.15041 1.13281 2.6547 1.13281 4.49328C1.13281 5.47942 2.10224 6.36528 3.63996 7.00042",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63996 17.0289C2.10224 16.3937 1.13281 15.5079 1.13281 14.5217V4.49316",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63996 12.015C2.10224 11.3798 1.13281 10.494 1.13281 9.50781",
    stroke: "#6D6584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2962_94285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalWallet);
export default __webpack_public_path__ + "static/media/digitalWallet.f17462a46b97ea46576b00c055d37633.svg";
export { ForwardRef as ReactComponent };